export enum UserRole {
  administrator = "administrator",
  clubAdmin = "clubAdmin",
  shooter = "shooter",
}
